'use client'

import dynamic from 'next/dynamic'
import { ReactNode } from 'react'

import '@/components/Slider/Slider.scss'
import { CarouselProps } from '@/types/ContentModel/ContentModelBox'

const SliderLogic = dynamic(() => import('@/components/Slider/SliderLogic'), {
  ssr: true,
})

export default function Slider({ items, carouselProps }: { items: ReactNode[]; carouselProps: CarouselProps }) {
  return (
    <>
      <SliderLogic items={items} carouselProps={carouselProps} />
    </>
  )
}
